import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

import { Radio, Input as AntdInput } from 'antd';

import { type PriceFormValues } from '@eduzz-product-manager/validators';

import { ErrorMessage } from '@/components/form/ErrorMessage';
import { Input } from '@/components/form/Input';
import { plural } from '@/lib/plural';
import useProductStore from '@/stores/productStore';

export const RecurrenceCount = () => {
  const form = useFormContext<PriceFormValues>();

  const { recurrenceCount } = useProductStore(d => ({
    recurrenceCount: d.payment.recurrenceCount ?? 0
  }));

  const updateRecurrenceCount = useCallback(
    (value: number) => {
      form.setValue('recurrenceCount', value);
    },
    [form]
  );

  return (
    <>
      <span className='block pb-2 font-normal'>Cobrança termina em</span>

      <div className='flex flex-col'>
        <Radio checked={recurrenceCount === 0} onClick={() => updateRecurrenceCount(0)}>
          {' '}
          Nunca
        </Radio>
        <div className='flex flex-row items-center gap-2 pt-2'>
          <Radio checked={recurrenceCount > 0} onClick={() => updateRecurrenceCount(12)}>
            Após
          </Radio>
          <>
            {recurrenceCount > 0 ? (
              <Input hideError id='recurrenceCount' className='w-20!' type='number' name='recurrenceCount' />
            ) : (
              <AntdInput
                disabled
                id='recurrenceCountTmp'
                className='w-20!'
                type='number'
                value={12}
                name='recurrenceCount'
              />
            )}
            {plural(recurrenceCount, 'cobrança')}
          </>
        </div>
        <ErrorMessage fieldName='recurrenceCount' />
      </div>
    </>
  );
};
